import { APIServiceError } from 'frontcore/data/api-service/service-error/errors/service-error'


export class APIServiceException<SD = unknown> extends APIServiceError<SD> {}

export class MissingParameterError extends APIServiceException {}
